import script from "./BallotBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BallotBox.vue?vue&type=script&setup=true&lang=js"

import "./BallotBox.vue?vue&type=style&index=0&id=00a5f334&lang=css"

const __exports__ = script;

export default __exports__